import { Image, Flex } from '@mantine/core';
import { AuthWrapper, LoginForm } from 'src/components';
import LoginImage from 'src/assets/svg/slide-1.svg';
import classNames from 'classnames';

import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import { useDocumentTitle } from '@mantine/hooks';
import AuthWrraperGrid from 'src/components/AuthWrraperGrid/page';

const LoginPage = (): JSX.Element => {
  const [t] = useTranslation('auth');

  useDocumentTitle(t('loginPageTitle'));

  return (
    <AuthWrraperGrid    leftColumn= { <div className={classNames(styles.column, styles.left)}><LoginForm /></div>  }  />
 
    // <AuthWrapper
    //   leftColumn={ <LoginForm />  }
    //   rightColumn={
    //     <Flex direction={'column'} align={'center'}>
    //       <h1 dangerouslySetInnerHTML={{ __html: `${t('introductionLogin')}` }} className={styles.title}></h1>
    //       <p className={styles.description}>{t('makeTechnology')}</p>
    //       <Image maw={400} mx={'auto'} radius={'md'} src={LoginImage} alt={`${t('introductionImageLabel')}`} />
    //     </Flex>
    //   }
    // />
  );
};

export default LoginPage;
